import React from 'react';

import { Container } from './styles';
import { Props, Type } from './types';

const TextField: React.FC<Props> = ({ children, type = Type.primary }) => (
  <Container
    type={type}
    exit={{ opacity: 0 }}
    initial={{ y: 10, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
  >
    {children}
  </Container>
);

export default TextField;
